import React from 'react'
import Generador from '../components/Generador'

const generador = () => {
  return (
    <Generador />
  )
}

export default generador